var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoldsign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7996 31.6126C24.5255 31.6126 31.5992 24.5359 31.5992 15.8063C31.5992 7.07673 24.5255 0 15.7996 0C7.07372 0 0 7.07673 0 15.8063C0 24.5359 7.07372 31.6126 15.7996 31.6126Z",
    fill: "#FF4800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9507 18.143L15.0488 25.7874C14.9394 26.079 14.6715 26.2173 14.4073 26.2061C14.1658 26.1949 13.9281 26.0566 13.8262 25.7912L7.59235 9.56401C7.53575 9.41822 7.5999 9.28738 7.70555 9.2201C7.81121 9.15281 7.95838 9.14907 8.06781 9.26122L13.6866 14.9469C13.3696 15.859 13.7847 16.973 14.962 17.3393C15.2224 17.4215 15.5092 17.4253 15.7696 17.3468C17.279 16.8945 17.5733 15.1936 16.6488 14.2591C16.1432 13.747 15.4186 13.6124 14.7885 13.8367L9.15459 8.13231C9.04515 8.02016 9.04893 7.87438 9.12063 7.77345C9.18855 7.66878 9.3244 7.60897 9.46779 7.66504L25.5468 13.9862C25.8222 14.0946 25.9581 14.3413 25.9581 14.588C25.9581 14.8348 25.8185 15.0815 25.543 15.1899L17.9507 18.143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldsign);
export default __webpack_public_path__ + "static/media/boldsign.9ae1987d008373e241ba4798ec6b53e1.svg";
export { ForwardRef as ReactComponent };